import { ChangeDetectionStrategy, Component, inject, input, signal } from "@angular/core";

import { ClickAreaDirective } from "@directives";
import { TranslatePipe } from "@pipes";
import { AnalyticsService } from "@services";
import { Utils } from "@utils";

import { SvgComponent } from "../svg/svg.component";

@Component({
  selector: "mn-copy",
  templateUrl: "./copy.component.html",
  styleUrls: ["./copy.component.scss"],
  imports: [SvgComponent, TranslatePipe, ClickAreaDirective],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CopyComponent {
  private readonly anS = inject(AnalyticsService);

  public value = input.required<string>();
  public aEvent = input.required<string>();

  public to = signal<boolean>(false);

  public copy(event: Event): void {
    event.stopPropagation();

    const value = this.value();

    try {
      navigator.clipboard.writeText(value);
    } catch {
      const textarea = document.createElement("textarea");
      textarea.value = value;
      textarea.readOnly = true;
      textarea.style.position = "fixed";
      textarea.style.left = "-9999px";

      document.body.appendChild(textarea);
      textarea.focus();
      textarea.select();
      document.execCommand("copy");
      document.body.removeChild(textarea);
    }

    this.anS.client(this.aEvent());

    this.to.set(true);
    setTimeout(() => this.to.set(false), Utils.second);
  }
}
